import { createSlice, useDispatch } from '@oceanjs/core';
import { useCallback } from 'react';
import { useLibrarySelector } from '../internal/hooks/useLibrarySelector';
const initialState = {};
const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            state.name = action.payload.name;
            state.theme = action.payload.theme;
        },
    },
});
export const { setTheme } = themeSlice.actions;
export const themeReducer = themeSlice.reducer;
/**
 * Returns the name of the active theme
 * @returns Active theme name
 */
export function useThemeName() {
    return useLibrarySelector((state) => state.theme.name);
}
/**
 * Returns the theme value for the given key
 * @param themeKey Key
 * @param defaultValue Default value
 * @returns Theme value or if not present the default value
 */
export function useThemeValue(themeKey, defaultValue) {
    const themeValue = useLibrarySelector((state) => { var _a; return (_a = state.theme.theme) === null || _a === void 0 ? void 0 : _a[themeKey]; });
    if (themeValue === undefined) {
        console.warn(`Could not get theme value '${themeKey}'. Please provide a value in your theme.`);
        return defaultValue;
    }
    return themeValue;
}
/**
 * Creates a callback to change the current theme
 * @returns Callback to change the app theme
 */
export function useSwitchTheme() {
    const dispatch = useDispatch();
    return useCallback((themeName, theme) => dispatch(setTheme({ name: themeName, theme })), [dispatch]);
}
//# sourceMappingURL=theme.js.map